export default "__VITE_ASSET__B7LS39lJ__"